// extracted by mini-css-extract-plugin
export default {"serverErrorsContainer":"ListOfErrors_serverErrorsContainer__vCEMT","serverErrors":"ListOfErrors_serverErrors__UAgeH"};